import { object, string, ref } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();

    return object().shape({
        financier_group: string().required(REQUIRED_TEXT).nullable(),
        first_name: string().required(REQUIRED_TEXT),
        last_name: string().required(REQUIRED_TEXT),
        email: string().required(REQUIRED_TEXT),
        password: string().when('$isNewRecord', {
            is: true,
            then: () => string().required(REQUIRED_TEXT),
            otherwise: () => string().nullable(),
        }),
        confirm_password: string().when('$isNewRecord', {
            is: true,
            then: () =>
                string()
                    .required(REQUIRED_TEXT)
                    .oneOf(
                        [ref('password'), null],
                        'Las contraseñas deben coincidir',
                    ),
            otherwise: () => string().nullable(),
        }),
    });
};
